import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

import * as React from 'react';
import styled from 'styled-components';
import { verticalSpace } from '@doltech/utils/lib/css-style';

const Container = styled.div`
  display: grid;
  padding: 20px 16px 32px;
  margin: 0 auto;

  .content-wrapper {
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    gap: 32px;
  }

  .three-dot-horizontal {
    display: none;
  }

  .main-section {
    ${verticalSpace(24)};
  }

  .recommend-blog-list {
    ${verticalSpace(40)}
  }

  ${fromScreen(768)} {
    padding: 32px 28px 64px;
    margin: 0 auto;

    .content-wrapper {
      display: grid;
      width: 712px;
      gap: 64px;
    }

    .three-dot-horizontal {
      display: flex;
      justify-content: center;
    }

    .main-section {
      ${verticalSpace(32)};
    }

    .recommend-blog-list {
      ${verticalSpace(64)}
    }
  }

  ${fromScreen(1240)} {
    padding: 40px 0 64px;
  }
`;

interface StudentDoTestGrammarLandingTemplateProps {
  grammarBlog: React.ReactNode;
  grammarAction?: React.ReactNode;
  relatedGrammar?: React.ReactNode;
  sameTopicGrammar?: React.ReactNode;
  headerInfo?: React.ReactNode;
  grammarBreadcrumb?: React.ReactNode;
  hasThreeDot?: boolean;
}

export const StudentDoTestGrammarBlogTemplate = (props: StudentDoTestGrammarLandingTemplateProps) => {
  const { grammarBlog, grammarBreadcrumb, grammarAction, sameTopicGrammar, relatedGrammar, hasThreeDot } = props;
  return (
    <Container>
      <div className="content-wrapper">
        <div className="main-section">
          {grammarBreadcrumb}
          {grammarBlog}
          {hasThreeDot &&
            <Separator className="three-dot-horizontal" variant="three-dot-horizontal" bg="gray100"/>
          }
          {grammarAction}
        </div>
        <section id="recommend-blog-list" className="recommend-blog-list">
          {relatedGrammar}
          {sameTopicGrammar}
        </section>
      </div>
    </Container>
  );
};
